angular.module('impactx.rfx').controller('RFQCHistoryListCtrl', [
    'dataGen',
    '$route',
    'selectedListItems',
    'ToastService',
    '$routeParams',
    RFQCHistoryListCtrl]);

function RFQCHistoryListCtrl(dataGen, $route, selectedListItems, ToastService, $routeParams) {
    var ctrl = this;

    this.copyConfiguration = function () {
        var selectedIds = selectedListItems.getSelectedIds();
        var selectedIdsAsInteger = [];
        for (var i = 0; i < selectedIds.length; i++) {
            selectedIdsAsInteger.push(parseInt(selectedIds[i]));
        }
        var temp = {};
        dataGen.postAsForm(temp, {
            rfqcIds: selectedIdsAsInteger
        }, "/rfx/copyrfqc").then(function () {
            ToastService.openStandardToast(temp.trns.copySuccess);
            $route.reload();
        });
    };

    this.getDetailLink = function() {
        return "rfqcedit/" + selectedListItems.getFirstSelectedId();
    };

    this.canDeactivate = function()
    {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().status == 1;
    };

    this.canActivate = function()
    {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canBeActivated.value;
    };

    this.activate = function() {
        var temp = {};
        dataGen.postAsForm(temp, {
            rfqcId: selectedListItems.getFirstSelectedId()
        }, "/rfx/activate").then(function () {
            ToastService.openStandardToast(temp.trns.activateSuccess);
            $route.reload();
        });
    };

    this.deactivate = function() {
        var temp = {};
        dataGen.postAsForm(temp, {
            rfqcId: selectedListItems.getFirstSelectedId()
        }, "/rfx/deactivate").then(function () {
            ToastService.openStandardToast(temp.trns.deactivateSuccess);
            $route.reload();
        });
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'RFQCView'},
        {
            label: "copyConfiguration",
            action: ctrl.copyConfiguration,
            condition: selectedListItems.isMultiSelection,
            process: 'RFQCEdit'
        },
        {
            label: "activate",
            action: ctrl.activate,
            condition: ctrl.canActivate,
            process: 'RFQCEdit'
        },
        {
            label: "deactivate",
            action: ctrl.deactivate,
            condition: ctrl.canDeactivate,
            process: 'RFQCEdit'
        }
    ];

    this.meta = {
        rowTemplate: 'modules/rfx/templates/rfqclist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfx/listrfqchistory',
        id: "rfqchistorylist",
        params: {'baseNo': $routeParams.baseNo},
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function () {
        return this.meta;
    }
}
